<template>
  <div v-if="showHeaderActions" class="actions flex items-center">
    <button v-if="conversationStatus === 'open' && hasEndConversationEnabled" class="button transparent compact" :title="$t('END_CONVERSATION')" @click="resolveConversation">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" height="22" width="22" aria-hidden="true" :class="$dm('text-black-900 opacity-50 hover:opacity-100', 'dark:text-slate-50 opacity-50 hover:opacity-100')">
        <g>
          <path fill="currentColor" fill-rule="evenodd" d="M41.9216 7.41624C42.2057 10.4177 42.5 15.561 42.5 24c0 8.439 -0.2943 13.5823 -0.5784 16.5838 -0.2769 2.9251 -2.4852 5.1168 -5.3955 5.4062 -2.5781 0.2565 -6.6199 0.51 -12.526 0.51 -5.9062 0 -9.948 -0.2535 -12.5262 -0.51 -2.91029 -0.2894 -5.11861 -2.4811 -5.39548 -5.4063C5.79433 37.5823 5.5 32.439 5.5 24s0.29433 -13.5823 0.57842 -16.58373c0.27687 -2.92517 2.48519 -5.11683 5.39548 -5.40631C14.0521 1.75352 18.0939 1.5 24.0001 1.5c5.9061 0 9.9479 0.25352 12.526 0.50996 2.9103 0.28948 5.1186 2.48112 5.3955 5.40628ZM29 21c-1.6569 0 -3 1.3431 -3 3s1.3431 3 3 3h4c1.6569 0 3 -1.3431 3 -3s-1.3431 -3 -3 -3h-4Z" clip-rule="evenodd" stroke-width="1"></path>
        </g>
      </svg>
    </button>
    <button v-if="showPopoutButton" class="button transparent compact new-window--button " @click="popoutWindow">
      <fluent-icon icon="open" size="22" :class="$dm('text-black-900', 'dark:text-slate-50')" />
    </button>
    <button
      class="button transparent compact close-button"
      :class="{
        'rn-close-button': isRNWebView,
      }"
      @click="closeWindow"
    >
      <fluent-icon icon="dismiss" size="24" :class="$dm('text-black-900', 'dark:text-slate-50')" />
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { IFrameHelper, RNHelper } from 'widget/helpers/utils';
import { popoutChatWindow } from '../helpers/popoutHelper';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin';
import configMixin from 'widget/mixins/configMixin';

export default {
  name: 'HeaderActions',
  components: { FluentIcon },
  mixins: [configMixin, darkModeMixin],
  props: {
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      conversationAttributes: 'conversationAttributes/getConversationParams',
    }),
    isIframe() {
      return IFrameHelper.isIFrame();
    },
    isRNWebView() {
      return RNHelper.isRNWebView();
    },
    showHeaderActions() {
      return this.isIframe || this.isRNWebView || this.hasWidgetOptions;
    },
    conversationStatus() {
      return this.conversationAttributes.status;
    },
    hasWidgetOptions() {
      return this.showPopoutButton || this.conversationStatus === 'open';
    },
  },
  methods: {
    popoutWindow() {
      this.closeWindow();
      const {
        location: { origin },
        chatwootWebChannel: { websiteToken },
        authToken,
      } = window;
      popoutChatWindow(origin, websiteToken, this.$root.$i18n.locale, authToken);
    },
    closeWindow() {
      if (IFrameHelper.isIFrame()) {
        IFrameHelper.sendMessage({ event: 'closeWindow' });
      } else if (RNHelper.isRNWebView) {
        RNHelper.sendMessage({ type: 'close-widget' });
      }
    },
    resolveConversation() {
      this.$store.dispatch('conversation/resolveConversation');
    },
  },
};
</script>
<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.actions {
  button {
    margin-left: $space-normal;
  }

  span {
    color: $color-border-dark;
    font-size: $font-size-large;
  }

  .close-button {
    display: none;
  }
  .rn-close-button {
    display: block !important;
  }
}
</style>
